/**
 * IntentGrid
 * Niyet seçimi grid'i
 */

import React from 'react';

export default function IntentGrid({ intents, selected, onSelect }) {
  return (
    <div className="oracle-intent-grid">
      {intents.map(intent => (
        <div
          key={intent.id}
          className={`oracle-glass-card oracle-intent-card ${selected === intent.id ? 'selected' : ''}`}
          onClick={() => onSelect(intent.id)}
          data-testid={`intent-${intent.id}`}
        >
          <div className="oracle-intent-icon">{intent.icon}</div>
          <div className="oracle-intent-label">{intent.label}</div>
        </div>
      ))}
    </div>
  );
}
